import axios from "axios";

/**
 * Calculates the date and days passed since the last relevant update day.
 * Updates happen on Saturday and Wednesday. Returns the most recent update date.
 */
export const getMostRecentUpdateInfo = (date) => {
  // Convert to IST
  let currentDate = new Date(
    date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
  );
  let currentDay = currentDate.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat

  let daysToPrevFri = (currentDay - 5 + 7) % 7;
  if (daysToPrevFri === 0) daysToPrevFri = 7;

  let daysToPrevTue = (currentDay - 2 + 7) % 7;
  if (daysToPrevTue === 0) daysToPrevTue = 7;

  let daysBack = Math.min(daysToPrevFri, daysToPrevTue);

  let targetDate = new Date(currentDate);
  targetDate.setDate(currentDate.getDate() - daysBack);

  return { targetDate, daysBack };
};

export const lastUpdateDate = () => {
  let today = new Date();

  const { targetDate, daysBack } = getMostRecentUpdateInfo(today);
  return formatUpdateDate(targetDate, daysBack);

  /**
   * Formats the date and the "days ago" string.
   */
  function formatUpdateDate(date, daysBack) {
    if (!date) return "";

    const dtf = new Intl.DateTimeFormat("en-US", {
      day: "numeric",
      month: "long",
      year: "2-digit",
      timeZone: "Asia/Kolkata",
    });
    const parts = dtf.formatToParts(date);
    const day = parts.find((p) => p.type === "day").value;
    const rawMonth = parts.find((p) => p.type === "month").value;
    const month =
      rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1).toLowerCase();
    const year2 = parts.find((p) => p.type === "year").value;

    let ago;
    if (daysBack === 0) {
      ago = "today";
    } else if (daysBack === 1) {
      ago = "1 day ago";
    } else {
      ago = `${daysBack} days ago`;
    }

    return `${day}-${month}-${year2} (${ago})`;
  }
};

export const lastUpdateDateMobile = () => {
  let today = new Date();

  const { targetDate, daysBack } = getMostRecentUpdateInfo(today);
  return formatUpdateDate(targetDate, daysBack);

  /**
   * Formats the date in compact chip format:
   * "3 Jan 2026 · 3d ago"
   */
  function formatUpdateDate(date, daysBack) {
    if (!date) return "";

    const dtf = new Intl.DateTimeFormat("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    });

    const formattedDate = dtf.format(date); // e.g. "3 Jan 2026"

    let ago;
    if (daysBack === 0) {
      ago = "today";
    } else if (daysBack === 1) {
      ago = "1 day ago";
    } else {
      ago = `${daysBack} days ago`;
    }

    return `${formattedDate}  (${ago})`;
  }
};

export const getCurrentMonthAndYear = () => {
  const today = new Date();
  const monthIndex = today.getMonth(); // Returns month index (0-11)

  const year = today.getFullYear(); // Returns the full year (e.g., 2024)

  // Convert the month index to a human-readable month name
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const fullMonthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonth = monthNames[monthIndex];
  return {
    month: currentMonth,
    year: year,
    fullMonth: fullMonthNames[monthIndex],
  };
};

const { month, year } = getCurrentMonthAndYear();

export const getPosts = async () => {
  const DEV_TO_URL = "https://dev.to/api/articles";

  try {
    const result = axios
      .get(DEV_TO_URL)
      .query({ username: "Carl-W" })
      .then((res) => {
        return res.body;
      });
    return result;
  } catch (error) {}
};
